import { render, staticRenderFns } from "./WidgetType_Table.vue?vue&type=template&id=d6b22c96"
import script from "./WidgetType_Table.vue?vue&type=script&lang=js"
export * from "./WidgetType_Table.vue?vue&type=script&lang=js"
import style0 from "./WidgetType_Table.vue?vue&type=style&index=0&id=d6b22c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports